import classNames from 'classnames';

import { WithClassName } from '@/blocks/components/types';

import styles from './Separator.module.scss';

type SeparatorProps = {
  variant?: 'vertical' | 'horizontal';
} & WithClassName;

export const Separator = ({ variant = 'horizontal', className }: SeparatorProps) => (
  <div
    className={classNames(
      styles.separator,
      {
        [styles.horizontal]: variant === 'horizontal',
        [styles.vertical]: variant === 'vertical',
      },
      className,
    )}
  ></div>
);
